import MainScreenAppBar from "../../components/MainScreenAppBar";
import { HotspotEditor } from "../../components/HotspotEditor/HotspotEditor";
import { getIsEmbedded } from "../../util/params";

export function MainScreen() {
  const isEmbedded = getIsEmbedded();

  return (
    <div
      style={{
        display: "flex",
        height: "100vh",
        maxHeight: "100vh",
        width: "100vw",
        maxWidth: "100vw",
        flexDirection: "column",
        overflow: "hidden",
      }}
    >
      {!isEmbedded && <MainScreenAppBar />}
      <HotspotEditor />
    </div>
  );
}
